import React from 'react';
import PropTypes from 'prop-types';

import colours from './Colours';
import { P3, CaptionLarge, Heading5, P2 } from './Text';
import Icon from './Icons/Icon';
import Skeleton from 'react-loading-skeleton';

const ActivityCard = (props) => {

    let iconContainerStyle = props.iconContainerStyle ? props.iconContainerStyle : { borderRadius: '8px' };

    return (
        <div className={"activity_card " + (props.noShadow ? "no-shadow" : "") + (props.onClick ? " clickable" : "")} onClick={props.onClick ? props.onClick : null}>
            <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', maxHeight: 40, borderBottom: `solid 1px ${colours.primary.grey04}`, paddingBottom: 12 }}>
                <CaptionLarge>{props.label}</CaptionLarge>
                {props.iconName ? <Icon name={props.iconName} size={24} style={iconContainerStyle} class='ds-activity-card-icon' /> : null}
            </div>
            <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', paddingTop: 8, minHeight: '56px' }}>
                {props.activityCards && props.activityCards.length > 1 ?
                    props.activityCards.map((card, index) => {
                        if (index == props.activityCards.length - 1) {
                            return (
                                <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                                    {card}
                                </div>
                            )
                        } else {
                            return (
                                <div style={{ display: 'flex', flex: 1, flexDirection: 'row', borderRight: `solid 1px ${colours.primary.grey03}` }}>
                                    {card}
                                </div>
                            )
                        }
                    }) :
                    props.activityCards}
            </div>
        </div>
    )
}

const ActivityCardItem = (props) => {
    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', alignItems: 'center', padding: 4, minHeight: '84px', textAlign: 'center', minWidth: '100%' }}>
                <>
                    {props.headerComponent ? props.headerComponent : <Heading5 style={{ color: colours.primary.black, minWidth: '100%' }}>{props.loading ? <Skeleton /> : props.headerValue}</Heading5>}
                    <P3 style={{ color: colours.primary.grey03, marginTop: props.subValue ? 8 : 0, minWidth: '100%' }}>{props.loading ? <Skeleton /> : props.labelValue ? props.labelValue : null}</P3>
                    <P2 style={{ color: colours.primary.grey01, minWidth: '100%' }}>{props.loading ? <Skeleton /> : props.subValue}</P2>
                </>
                {/* } */}
            </div>
        </div>
    )

}

const AcceptStringOrNumber = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
])

ActivityCard.propTypes = {
    activityCards: PropTypes.array,
    label: PropTypes.string,
    iconName: PropTypes.string,
    iconContainerStyle: PropTypes.object,
    noShadow: PropTypes.bool,
    onClick: PropTypes.func
}

ActivityCard.defaultProps = {
    activityCards: [],
    label: '',
    iconName: '',
    iconContainerStyle: null,
    noShadow: false,
    onClick: null
}

ActivityCardItem.propTypes = {
    loading: PropTypes.bool,
    labelValue: PropTypes.string,
    headerValue: AcceptStringOrNumber,
    subValue: AcceptStringOrNumber,
    headerComponent: PropTypes.element,
    subComponent: PropTypes.element
}

ActivityCardItem.defaultProps = {
    loading: false,
    labelValue: '',
    headerValue: '',
    subValue: '',
    headerComponent: null,
    subComponent: null
}

export { ActivityCard, ActivityCardItem };